import { lazy } from 'react';
import { LocalStorageKeys } from '@/constants/LocalStorage';
import { environment } from '@/utils/env.utils';

export const DevTools = lazy(() => import('@/devtools/devtools'));

export const shouldRenderDevTools = () => {
  const isDisabled = localStorage.getItem(LocalStorageKeys.DEVTOOLS) === 'false';
  const isDevOrTest = ['develop', 'local', 'test', 'sandbox', 'staging'].includes(environment.env);

  return isDevOrTest && !isDisabled;
};
